<template>
  <div class="d-flex align-center my-2">
    <v-text-field
      :label="$t('journal.search.criterias.timeDecay.input')"
      type="number"
      v-model="halfLife"
      @keydown.enter.prevent="submit"
      hide-details
      dense
      outlined
      :rules="rules"
    />
    <v-text-field
      :label="$t('journal.search.criterias.score')"
      type="number"
      class="ml-2"
      style="width: 150px; max-width: 150px;"
      v-model="multiplier"
      @keydown.enter.prevent="submit"
      hide-details
      dense
      outlined
      :rules="rules"
    />
  </div>
</template>
<script>
import { nanoid } from 'nanoid';
import { criterias } from '../SearchCriteria';

export default {
  name: 'TimeDecay',
  props: {
    params: {
      type: Object,
      default: undefined,
    },
  },
  data: () => ({
    multiplier: 0.2,
    halfLife: 14,
    include: true,
    id: `${criterias.TIME_DECAY}/${nanoid(10)}`,
    rules: [
      v => !!v || 'Ce champs ne peut être vide',
    ],
  }),
  created() {
    if (this.params !== undefined) {
      const data = this.params.scorings[0].TimeDecay;
      this.id = data.id;
      this.multiplier = Number.parseFloat(data.multiplier);
      this.halfLife = data.param.half_life.amount;
      this.include = data.kind === 'Include';
    }
  },
  methods: {
    submit() {
      this.$emit('submit');
    },
    getCriteria() {
      return {
        scorings: [
          {
            DateDecay: { // Small date decay
              multiplier: Number.parseFloat(this.multiplier),
              param: {
                half_life: {
                  amount: Number.parseInt(this.halfLife, 10),
                  unit: 'd',
                },
                kind: 'Gaussian',
              },
              id: this.id,
            },
          },
        ],
      };
    },
  },
};
</script>
